export default __webpack_public_path__ + "static/media/third-place.b5862697.svg";